import React from 'react'

import { usePathParams } from '~/routes/paths'

export const useMainQueryKey = () => {
  const { key } = usePathParams('restore')

  return React.useMemo(() => ['RestorePage_Main', { key }] as const, [key])
}
